import React, { memo } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import style from './GamesContentEmpty.scss';

export const GamesContentEmptyBare: React.FC<Types.IGamesContentEmptyProps> = ({ className }) => {
    const translate = useTranslations();

    return (
        <div className={`${style.emptyContent} ${className} cms-games-grid-no-items`}>{translate('playtech.mobile.system.games-grid.noGames')}</div>
    );
};

export const GamesContentEmpty = memo(GamesContentEmptyBare);
